export default [{
  path: '/late-to-works',
  name: 'lateToWorks',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/kpp/lateToWorks/index')
}]
